import ajax from '@/modules/ajax';

import { throttle } from '@/modules/helper';

export default class Zipcoder {
  constructor(options) {
    this.options = options;
    this.throttleSearch = throttle(this.search.bind(this));
    this.url = '/addresses/:zipcode';
    this.wrapper = document.querySelector(`[data-address="${options.scope}"]`);
  }

  always() {
    this.loading(false);
    this.lock(false);
  }

  bind() {
    this.zipCode.addEventListener('keypress', this.prevent.bind(this));

    this.zipCode.addEventListener('keyup', (evt) => {
      this.throttleSearch(evt, false);
    });

    this.zipCode.addEventListener('paste', (evt) => {
      this.throttleSearch(evt, true);
    });
  }

  clearFields() {
    const inputs = this.wrapper.querySelectorAll('input');

    for (const input of inputs) {
      if (input.type !== 'hidden') input.value = '';
    }
  }

  create() {
    if (!this.wrapper) {
      return;
    }

    this.setVariables(this.wrapper);
    this.bind();
  }

  key(evt) {
    return evt.keyCode || evt.charCode;
  }

  loading(bool) {
    this.zipCode.parentElement.classList[bool ? 'add' : 'remove']('loading');
  }

  lock(boo) {
    this.fields.forEach((field) => {
      field.readOnly = boo;
    });
  }

  request() {
    this.zipCode.dataset.ready = false;

    ajax({
      always: this.always.bind(this),
      done: this.populate.bind(this),
      loading: (bool) => {
        this.lock(bool);
        this.loading(bool);
      },
      url: this.url.replace(':zipcode', this.rawZipCode()),
    });
  }

  isNumber(evt) {
    const key = this.key(evt);

    return key >= 48 && key <= 57;
  }

  isSearch(evt, paste) {
    return (paste || this.isNumber(evt)) && this.rawZipCode().length === 8;
  }

  populate(json) {
    this.clearFields();

    this.zipCode.value = json.zip_code;
    this.zipCode.dataset.ready = true;

    this.number.focus();

    this.street.value = json.street;
    this.neighborhood.value = json.neighborhood;
    this.city.value = json.city;
    this.state.value = json.state;

    if (this.complement) {
      this.complement.value = json.complement;
    }

    if (this.options.callback) {
      this.options.callback();
    }
  }

  prevent(evt) {
    if (!this.isNumber(evt)) {
      evt.preventDefault();

      return false;
    }
  }

  rawZipCode() {
    return this.zipCode.value.replace('_', '').replace('-', '');
  }

  search(evt, paste) {
    if (this.isSearch(paste, evt)) this.request();
  }

  setVariables(wrapper) {
    this.city = wrapper.querySelector('[data-city-field]');
    this.complement = wrapper.querySelector('[data-complement-field]');
    this.fields = wrapper.querySelectorAll('input');
    this.neighborhood = wrapper.querySelector('[data-neighborhood-field]');
    this.number = wrapper.querySelector('[data-number-field]');
    this.state = wrapper.querySelector('[data-state-field]');
    this.street = wrapper.querySelector('[data-street-field]');
    this.zipCode = wrapper.querySelector('[data-zip-code-field]');

    this.model = this.zipCode.name.split('[')[0];
  }
}
